export default __webpack_public_path__ + "static/media/continue_icon01.2987ea48.svg";